export enum EParamType {
	SELECT = 'select',
	TEXT = 'text',
	NUMBER = 'number',
}

export enum EStepType {
	YES_NO = 'yes-no',
	NEXT = 'next',
	SUBMIT = 'submit',
}

type StepBase = {
	id: string;
	question: string;
};

export type YesNoStep = StepBase & {
	stepType: EStepType.YES_NO;
	yes: string;
	no: string;
};

export type Param = {
	param: string;
	name: string;
};

export type TSelectParam = Param & {
	options: SelectOption[];
	paramType: EParamType.SELECT;
};

export type SelectOption = { id: number; name: string };

export type TextParam = Param & {
	paramType: EParamType.TEXT;
};

export type NumberParam = Param & {
	paramType: EParamType.NUMBER;
};

export type SubmitStep = StepBase & {
	stepType: EStepType.SUBMIT;
};

export type NextStep = StepBase & {
	stepType: EStepType.NEXT;
	params: Array<TSelectParam | TextParam | NumberParam>;
};

export type Step = YesNoStep | NextStep | SubmitStep;

export type AnswersState = Record<string, string>;
